import React, {useState, useEffect} from "react"
import {useDispatch, useStore} from "../Store"
import {useTranslation} from "react-i18next"
import {useOnUpdate} from "../hooks"
import "../i18n"
import VirtualSelect from "../components/VirtualSelect"

export default function SenarioTerm({id = null}) {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const {
    store: {locale, perspective, senarioTermIds, termList, rankingListParam, rankingListTarget},
  } = useStore()

  const getValue = () => {
    let value = termList[perspective].find((h) => h.key === rankingListTarget.term)
    if (!value) {
      value = termList[perspective].find((h) => h.key === rankingListParam[perspective].term)
      if (!value) {
        value = termList[perspective][0]
      }
    }
    return value
  }

  const setValue = (v) => {
    if (rankingListTarget.term === v.key)
      return
    dispatch({
      type: `RANKING_LIST_TARGET`,
      term: v.key
    })
  }

  const [key, setKey] = useState(false)
  const useSenarioTerm = () => {
    setKey(!key)
  }
  useOnUpdate(useSenarioTerm, [locale])

  useEffect(() => {
    setValue(getValue())
  }, [perspective])

  const handleChange = async (v) => {
    if (id !== senarioTermIds[perspective])
      return
    if (!v) {
      setValue(getValue())
    } else {
      setValue(v)
    }
  }

  return (
    <VirtualSelect
      id={senarioTermIds[perspective]}
      key={key}
      required={false}
      target={`senarioTerm`}
      label={locale === `ja` ? `labelJa` : `labelEn`}
      inputLabel={t(`senarioTerm`)}
      options={termList[perspective]}
      onChange={handleChange}
      value={getValue()}
    />
  )
}
